import "@fmr-ap109253/apex-kit/dist/umd/pvd.min.js";
import "@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js";
import "@webcomponents/webcomponentsjs/webcomponents-bundle.js";

import {
    PvdButton,
    PvdContentBlock,
    PvdFieldGroup,
    PvdFootnote,
    PvdForm,
    PvdIcon,
    PvdInlineAlert,
    PvdInput,
    PvdLink,
    PvdMicrocopy,
    PvdPopover,
    PvdSelect,
    injectSpriteSheet
} from '@fmr-ap109253/apex-kit';

import HighchartsVue from 'highcharts-vue';
import Vue from 'vue';
import App from './App.vue';

injectSpriteSheet();
PvdButton.defineCustomElement();
PvdIcon.defineCustomElement();
PvdContentBlock.defineCustomElement();
PvdFootnote.defineCustomElement();
PvdLink.defineCustomElement();
PvdForm.defineCustomElement();
PvdPopover.defineCustomElement();
PvdFieldGroup.defineCustomElement();
PvdSelect.defineCustomElement();
PvdInput.defineCustomElement();
PvdMicrocopy.defineCustomElement();
PvdInlineAlert.defineCustomElement();


Vue.config.productionTip = false;
Vue.use(HighchartsVue);
new Vue({
    render: (h) => h(App),
}).$mount('#app');
